import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DragTrackerService {
  public isDragging: Observable<boolean>;
  private isDraggingSubject: BehaviorSubject<boolean>;

  constructor() {
    this.isDraggingSubject = new BehaviorSubject<boolean>(false);
    this.isDragging = this.isDraggingSubject.asObservable();
  }

  public set isDraggingSetValue(isDragging: boolean) {
    this.isDraggingSubject.next(isDragging);
  }
}
